import { render, staticRenderFns } from "./Announcements.vue?vue&type=template&id=1d604b52&scoped=true"
import script from "./Announcements.vue?vue&type=script&lang=js"
export * from "./Announcements.vue?vue&type=script&lang=js"
import style0 from "./Announcements.vue?vue&type=style&index=0&id=1d604b52&prod&scoped=true&lang=css"
import style1 from "./Announcements.vue?vue&type=style&index=1&id=1d604b52&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d604b52",
  null
  
)

export default component.exports